<!--
<a style="cursor: pointer; text-decoration: underline;" (click)="filterByLetter_click('a')">A</a>&nbsp;&nbsp;
<a style="cursor: pointer; text-decoration: underline;" (click)="filterByLetter_click('b')">B</a>&nbsp;&nbsp;
-->
<table class="cpo-selectable-table">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      <th [hidden]="!options || options.allowFavorites == false" class="no-sort"></th>
      <th [hidden]="options.hiddenFields?.includes('DBA')" class="no-sort">DBA Name</th>
      <th [hidden]="options.hiddenFields?.includes('MID')" class="no-sort">MID</th>
      <th [hidden]="options.hiddenFields?.includes('status')" class="no-sort">Status</th>
      <th [hidden]="options.hiddenFields?.includes('streetAddress')" class="no-sort">Address</th>
      <th [hidden]="options.hiddenFields?.includes('contact')" class="no-sort">Contact</th>
      <th [hidden]="!this.options.allowEditing" class="no-sort" ></th>
      <!--<th></th>-->
    </tr>
  </thead>
  <tbody>
    @if (loading) {
      <tr>
        <td colspan="7">
          <div class="cpo-table-loading">
            <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
          </div>
        </td>
      </tr>
    } @else {
    @for (
      item of this.dataSource.data;
      track item.id;
      let even = $even;
      let odd = $odd
    ) {
      @if (item.id != undefined) {
        <tr id="trsummary_{{ item.id }}" [ngClass]="{ even: even, odd: odd }" class="cpo-selectable-table__row">
          <td [hidden]="!options || options.allowFavorites == false" class="action" style="width: 30px; align-items: center;">
            <app-star [recordId]="item.id" [selected]="item.myMerchant" (starSelected)="recordStarred($event)" (starDeselected)="recordUnstarred($event)"></app-star>
          </td>
          <td class="selectable" [hidden]="options.hiddenFields?.includes('DBA')" (click)="btnManageAccount_click(item.id)">
            {{ item.DBA }}
          </td>
          <!-- <td [hidden]="options.hiddenFields?.includes('MID')">
            {{ item.MID }}
          </td> -->
          <td [hidden]="options.hiddenFields?.includes('MID')">
            @for (p of item.processors; track p.mid) {
              <div>{{ p.mid }} ({{ p.processor }})</div>
            }
          </td>

          <td class="cpo-selectable-table__cell" [hidden]="options.hiddenFields?.includes('status')">
            <span
              class="cpo-selectable-table__status"
              [class.complete]="item.accountStatus == 'Live'"
              [class.canceled]="item.accountStatus == 'Disabled'"
              [class.pending]="item.accountStatus == 'Test'"
            >
            @if (item.accountStatus == 'Live') {
              <svg width="16" height="16">
                <circle cx="8" cy="8" r="3" fill="var(--green-900)" />
              </svg>
            } @else if (item.accountStatus == 'Test') {
              <svg width="16" height="16">
                <circle cx="8" cy="8" r="3" fill="var(--gray-900)" />
              </svg>
            } @else {
              <svg width="16" height="16">
                <circle cx="8" cy="8" r="3" fill="red" />
              </svg>
            }
              {{ item.accountStatus }}
            </span>
          </td>
          <td
            [hidden]="options.hiddenFields?.includes('streetAddress')"
          >
            {{ item.streetAddress.city }}, {{ item.streetAddress.state }}
          </td>
          <td
            [hidden]="options.hiddenFields?.includes('contact')"
          >
            {{ item.contacts }}
          </td>
          <td [hidden]="!this.options.allowEditing">
            <app-icon type="Trash" (click)="deleteMerchantUser(item.id)" [color]="'var(--archive-red)'" style="cursor: pointer;"></app-icon>
          </td>
        </tr>
      }
      @if (this.options.selectAction == 'expand') {
        <tr
          id="trdetails_{{ item.id }}"
          class="rowDetails noHover"
          style="display: none"
        >
          <td colspan="6">
            <div style="height: 100px">[helpful at-a-glance info goes here]</div>
          </td>
        </tr>
      }
    }
  }
  </tbody>
</table>

<!-- <div
  style="
    padding: 10px 0px 0px 10px;
    font-size: 0.9em;
    font-style: italic;
    color: #888888;
  "
  [hidden]="!options || options.allowFavorites == false || !canSelectFavorites"
>
  <app-icon
    [type]="IconType.StarOpen"
    [class]="'xsmall'"
    [color]="'var(--colorFavoriteStar)'"
  ></app-icon>
  Click the star to add or remove from your favorites
</div> -->
